import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { LocalstorageKey, FontAwesomeType } from '../..';

@Injectable({
  providedIn: 'root'
})
export class FontawesomeTypeService {

  private _fontawesomeTypes = FontAwesomeType;
  private _STORAGE_KEY = LocalstorageKey.FontawesomeType;

  private _selectedFontawesomeType = new BehaviorSubject<IconPrefix>(null);
  public selectedFontawesomeType$ = this._selectedFontawesomeType.asObservable();

  public get fontawesomeTypes() {
    return this._fontawesomeTypes;
  }

  constructor(
    private _localStorageService: LocalStorageService
  ) { }

  public initTheme() {
    const currentFontawesomeType = this._localStorageService.get<string>(this._STORAGE_KEY);

    this.setType(currentFontawesomeType || (FontAwesomeType.Regular as any));
  }

  public setType(type: IconPrefix) {
    this._selectedFontawesomeType.next(type);
    this._localStorageService.set({ key: this._STORAGE_KEY, value: type });
  }

}

